// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3qMGl","errors":"Errors_errors__XlA3f"};